export var CouponApplyPhase;
(function (CouponApplyPhase) {
    CouponApplyPhase["PreApply"] = "PreApply";
    CouponApplyPhase["PostApply"] = "PostApply";
})(CouponApplyPhase || (CouponApplyPhase = {}));
//# sourceMappingURL=coupon-qualifier.interface.js.map